/* Package JSON Import will be here */
import React from "react";
import { Button, Modal, Row, Col } from "antd";
import { useSelector } from "react-redux";
import { getTranslate } from "react-localize-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import { Spinner } from "components/Spinner"
import NoData from "components/reusable/NoData";
/* Project Import will be here */

const ContractAgreementModel = (props) => {
    const { translate, staticContent } = useSelector((state) => ({
        translate: getTranslate(state.locale),
        staticContent: state.staticContent
    }));

    const renderComponent = () => {
        if (staticContent.isLoading) {
            return (
                <div className="container pt-5">
                    <Spinner message={props.translate("common.loaderMessage")} />
                </div>
            );
        }
        else if (staticContent.isEnableOnboardContractAgreement !== null) {
            return (
                <React.Fragment>
                    <h5 className="font-bold">{translate("contractAgreement.title")}</h5>

                    {staticContent.contractAgreement.contractAgreementPointList.map((item, index) => {
                        return (
                            <div className="a-text-underline p-2" key={index} dangerouslySetInnerHTML={{ __html: item.replace(/&lt;/g, '<').replace(/&gt;/g, '>') }} />
                        )
                    })}
                </React.Fragment>
            );
        }
        else {
            return (
                <div className="container pt-2">
                    <NoData NoDataMessage={translate("common.noDataMessage")} />
                </div>
            );
        }
    }

    return (
        <React.Fragment>
            <Modal
                visible={props.isShowContractAgreementModal}
                centered
                closable={false}
                footer={null}
                className="order-terms-and-condition-modal"
            >
                <React.Fragment>
                    {renderComponent()}

                    <Row justify="end">
                        <Col span={24} md={12} className="p-2">
                            <Button block shape="round" type="primary" onClick={props.onAgreeContractAgreement}>
                                {translate("common.buttons.agree")}
                            </Button>
                        </Col>
                    </Row>
                </React.Fragment>
            </Modal>
        </React.Fragment>
    );
};

export default ContractAgreementModel;